export default __webpack_public_path__ + "2b51161aa124c6d33b272498e07be5b6.svg";